import axios from "axios";

export default class AxiosClient {

    postRequest(url, body, successCallBack, failureCallBack) {
        axios.post(url, body)
             .then(successCallBack)
             .catch(failureCallBack);
    }
}